import PropTypes from 'prop-types'
import React from 'react'

import {
    Flex,
    HStack,
    Text,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {styleConfigChakraKeys} from '../../constants'
import Link from '../link'
import ScrollerNavigationButtons from './scroller-navigation-buttons'

const ScrollerHeader = ({
    isLoading,
    scroll,
    viewAll,
    title,
    showScrollerNav = false
}) => {
    const styles = useMultiStyleConfig(styleConfigChakraKeys.productScroller)
    if (!title && !showScrollerNav) return <></>

    return (
        <Flex
            width="100%"
            alignItems="flex-end"
            justifyContent={{base: 'center', lg: 'space-between'}}
        >
            <Text
                fontFamily="Raleway"
                fontWeight={{base: '600', lg: '500'}}
                fontSize={{base: '24px', lg: '24px'}}
                lineHeight={{base: '20px', lg: '32px'}}
            >
                {title}
            </Text>
            {showScrollerNav && (
                <HStack gap={{lg: '51px'}}>
                    {!isLoading && (
                        <ScrollerNavigationButtons scroll={scroll} />
                    )}
                    {viewAll && (
                        <Link
                            buttonStyles={styles.viewAllButton}
                            _hover={{
                                fontWeight: 'bold'
                            }}
                            {...viewAll}
                        />
                    )}
                </HStack>
            )}
        </Flex>
    )
}

ScrollerHeader.displayName = 'ScrollerHeader'

ScrollerHeader.propTypes = {
    title: PropTypes.any,
    isLoading: PropTypes.bool,
    showScrollerNav: PropTypes.bool,
    scroll: PropTypes.func,
    viewAll: PropTypes.shape({
        url: PropTypes.string,
        text: PropTypes.string,
        openLineInNewTab: PropTypes.bool,
        theme: PropTypes.object,
        type: PropTypes.string,
        isExternal: PropTypes.bool,
        externalUrl: PropTypes.string
    })
}

export default ScrollerHeader
